import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ChipIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.76 5.5H7.24C6.63546 5.5 6.27529 5.50124 6.00865 5.52375C5.88006 5.5346 5.81066 5.54816 5.77825 5.55626C5.76601 5.55933 5.75438 5.56431 5.74354 5.57078C5.67256 5.61319 5.61319 5.67256 5.57078 5.74354C5.56431 5.75438 5.55933 5.76601 5.55626 5.77825C5.54816 5.81066 5.5346 5.88006 5.52375 6.00865C5.50124 6.27529 5.5 6.63546 5.5 7.24V8.76C5.5 9.36454 5.50124 9.72471 5.52375 9.99135C5.5346 10.1199 5.54816 10.1893 5.55626 10.2217C5.55933 10.234 5.56431 10.2456 5.57078 10.2565C5.61319 10.3274 5.67256 10.3868 5.74354 10.4292C5.75438 10.4357 5.76601 10.4407 5.77825 10.4437C5.81066 10.4518 5.88006 10.4654 6.00865 10.4763C6.27529 10.4988 6.63546 10.5 7.24 10.5H8.76C9.36454 10.5 9.72471 10.4988 9.99135 10.4763C10.1199 10.4654 10.1893 10.4518 10.2218 10.4437C10.234 10.4407 10.2456 10.4357 10.2565 10.4292C10.3274 10.3868 10.3868 10.3274 10.4292 10.2565C10.4357 10.2456 10.4407 10.234 10.4437 10.2217C10.4518 10.1893 10.4654 10.1199 10.4763 9.99135C10.4988 9.72471 10.5 9.36454 10.5 8.76V7.24C10.5 6.63546 10.4988 6.27529 10.4763 6.00865C10.4654 5.88006 10.4518 5.81066 10.4437 5.77825C10.4407 5.76601 10.4357 5.75438 10.4292 5.74354C10.3868 5.67256 10.3274 5.61319 10.2565 5.57078C10.2456 5.5643 10.234 5.55933 10.2217 5.55626C10.1893 5.54816 10.1199 5.5346 9.99135 5.52375C9.72471 5.50124 9.36454 5.5 8.76 5.5ZM4.23247 5.06414C4 5.5032 4 6.08213 4 7.24V8.76C4 9.91787 4 10.4968 4.23247 10.9359C4.42007 11.2902 4.70983 11.5799 5.06414 11.7675C5.5032 12 6.08213 12 7.24 12H8.76C9.91787 12 10.4968 12 10.9359 11.7675C11.2902 11.5799 11.5799 11.2902 11.7675 10.9359C12 10.4968 12 9.91787 12 8.76V7.24C12 6.08213 12 5.5032 11.7675 5.06414C11.5799 4.70983 11.2902 4.42007 10.9359 4.23247C10.4968 4 9.91787 4 8.76 4H7.24C6.08213 4 5.5032 4 5.06414 4.23247C4.70983 4.42007 4.42007 4.70983 4.23247 5.06414Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.25 5.75H11.2C11.0895 5.75 11 5.66046 11 5.55V4.45C11 4.33954 11.0895 4.25 11.2 4.25H14.25C14.6642 4.25 15 4.58579 15 5C15 5.41421 14.6642 5.75 14.25 5.75Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.25 11.75H11.2C11.0895 11.75 11 11.6605 11 11.55V10.45C11 10.3395 11.0895 10.25 11.2 10.25H14.25C14.6642 10.25 15 10.5858 15 11C15 11.4142 14.6642 11.75 14.25 11.75Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.25 8.75H11.2C11.0895 8.75 11 8.66046 11 8.55V7.45C11 7.33954 11.0895 7.25 11.2 7.25H14.25C14.6642 7.25 15 7.58579 15 8C15 8.41421 14.6642 8.75 14.25 8.75Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.25 14.25V11.2C10.25 11.0895 10.3395 11 10.45 11H11.55C11.6605 11 11.75 11.0895 11.75 11.2V14.25C11.75 14.6642 11.4142 15 11 15C10.5858 15 10.25 14.6642 10.25 14.25Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.25 14.25V11.2C4.25 11.0895 4.33954 11 4.45 11H5.55C5.66046 11 5.75 11.0895 5.75 11.2V14.25C5.75 14.6642 5.41421 15 5 15C4.58579 15 4.25 14.6642 4.25 14.25Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.25 14.25V11.2C7.25 11.0895 7.33954 11 7.45 11H8.55C8.66046 11 8.75 11.0895 8.75 11.2V14.25C8.75 14.6642 8.41421 15 8 15C7.58579 15 7.25 14.6642 7.25 14.25Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.75 1.75V4.8C5.75 4.91046 5.66046 5 5.55 5H4.45C4.33954 5 4.25 4.91046 4.25 4.8V1.75C4.25 1.33579 4.58579 1 5 1C5.41421 1 5.75 1.33579 5.75 1.75Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.75 1.75V4.8C11.75 4.91046 11.6605 5 11.55 5H10.45C10.3395 5 10.25 4.91046 10.25 4.8V1.75C10.25 1.33579 10.5858 1 11 1C11.4142 1 11.75 1.33579 11.75 1.75Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.75 1.75V4.8C8.75 4.91046 8.66046 5 8.55 5H7.45C7.33954 5 7.25 4.91046 7.25 4.8V1.75C7.25 1.33579 7.58579 1 8 1C8.41421 1 8.75 1.33579 8.75 1.75Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.75 10.25H4.8C4.91046 10.25 5 10.3395 5 10.45V11.55C5 11.6605 4.91046 11.75 4.8 11.75H1.75C1.33579 11.75 1 11.4142 1 11C1 10.5858 1.33579 10.25 1.75 10.25Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.75 4.25H4.8C4.91046 4.25 5 4.33954 5 4.45V5.55C5 5.66046 4.91046 5.75 4.8 5.75H1.75C1.33579 5.75 1 5.41421 1 5C1 4.58579 1.33579 4.25 1.75 4.25Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.75 7.25H4.8C4.91046 7.25 5 7.33954 5 7.45V8.55C5 8.66046 4.91046 8.75 4.8 8.75H1.75C1.33579 8.75 1 8.41421 1 8C1 7.58579 1.33579 7.25 1.75 7.25Z"
		/>
		<path
			fill="currentColor"
			d="M7 7.5C7 7.22386 7.22386 7 7.5 7H8.5C8.77614 7 9 7.22386 9 7.5V8.5C9 8.77614 8.77614 9 8.5 9H7.5C7.22386 9 7 8.77614 7 8.5V7.5Z"
		/>
	</svg>
))
